import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    open(event) {
        event.preventDefault()

        const template = document.getElementById("save-the-date-swal-template")
        if (!template) return

        Swal.fire({
            html: template.innerHTML,
            showConfirmButton: false,
            showCloseButton: true,
            width: 640,
            customClass: {
                popup: "save-the-date-swal-popup",
                closeButton: "save-the-date-swal-close"
            },
            didOpen: (popup) => {
                this.focusFirstField(popup)
                this.bindFieldValidation(popup)
                this.bindFormSubmit(popup)
            }
        })
    }

    focusFirstField(popup) {
        const input = popup.querySelector("#swal_child_name")
        if (input) input.focus()
    }

    bindFieldValidation(form) {
        const childNameInput = form.querySelector("#swal_child_name")
        const dateInput = form.querySelector("#swal_child_date")

        ;[childNameInput, dateInput].forEach((field) => {
            if (!field) return

            field.addEventListener("input", () => {
                const validationNode = Swal.getValidationMessage()
                if (validationNode) validationNode.textContent = ""
            })

            field.addEventListener("change", () => {
                const validationNode = Swal.getValidationMessage()
                if (validationNode) validationNode.textContent = ""
            })
        })
    }

    bindFormSubmit(popup) {
        const form = popup.querySelector("#save-the-date-swal-form")
        if (!form) return

        form.addEventListener("submit", async (event) => {
            event.preventDefault()

            const childNameInput = form.querySelector("#swal_child_name")
            const dateInput = form.querySelector("#swal_child_date")
            const submitButton = form.querySelector('button[type="submit"]')

            const childName = childNameInput?.value?.trim()
            const birthdate = dateInput?.value?.trim()

            if (!childName) {
                Swal.showValidationMessage("Please enter your child’s name.")
                childNameInput?.focus()
                return
            }

            if (!birthdate) {
                Swal.showValidationMessage("Please select your child’s birthdate.")
                dateInput?.focus()
                return
            }

            if (submitButton) submitButton.disabled = true
            Swal.showLoading()

            try {
                const response = await fetch(form.action, {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
                        "Accept": "application/json"
                    },
                    body: new FormData(form)
                })

                const data = await response.json()

                if (!response.ok || !data.success) {
                    throw new Error(data.message || "Something went wrong, please try again.")
                }

                Swal.close()

                Swal.fire({
                    icon: "success",
                    title: data.message || "Birthday reminder saved.",
                    position: "center",
                    showConfirmButton: false,
                    timer: 3500,
                    timerProgressBar: true,
                    customClass: {
                        popup: "echoage-toast-popup echoage-toast-popup--center",
                        title: "echoage-toast-title"
                    }
                })
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Couldn’t save reminder",
                    text: error.message || "Something went wrong, please try again."
                })
            } finally {
                if (submitButton) submitButton.disabled = false
            }
        })
    }
}